import { Image } from '@cian/ui-kit';
import * as React from 'react';

import { IPromoInfoSchema } from '../../types/promo';

import * as styles from './PromoItemIcon.css';
import { BankIcon } from './components/BankIcon';
import { PROMO_ICON } from './constants';

interface IPromoItemIconProps {
  promo: IPromoInfoSchema;
}

export function PromoItemIcon({ promo }: IPromoItemIconProps) {
  const { authorLogoUrl, promoType, bank, isBlackFriday } = promo;
  const isAuthorLogoVisible = isBlackFriday && authorLogoUrl;

  let icon: React.ReactNode;

  if (isAuthorLogoVisible) {
    icon = <Image src={authorLogoUrl} alt="logo" borderRadius="50%" objectFit="contain" />;
  } else if (promoType === 'bank') {
    icon = <BankIcon bank={bank} />;
  } else {
    const iconSrc = PROMO_ICON.get(promoType);

    if (iconSrc) {
      icon = <img src={iconSrc} alt={promo.name} />;
    }
  }

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>{icon}</div>
    </div>
  );
}
